import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { OrderPipe } from 'ngx-order-pipe';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-nec-guidelines',
  templateUrl: './nec-guidelines.component.html',
  styleUrls: ['./nec-guidelines.component.scss']
})
/** nec-guidelines component*/
export class NecGuidelinesComponent {
  /** nec-guidelines ctor */
  necGuidlines: any;
  route: any;
  MenuList: any;
  title: any;
  showhide: boolean;
  fileUrl: any;
  itemsPerPage: number;
  Search: any;
  paginationPageNumber: number;
  necGuidlinesCount: any;
  currentDate: any = new Date();
  modeltitle: any;
  content: any;
  image: any;
  multipleEntry: boolean = false;
  imgUrl: any;
  necSpinner: boolean;
  constructor(private spinner: NgxSpinnerService, private appComponent: AppComponent, private http: HttpClient, private router: Router, private datePipe: DatePipe, private orderpipe: OrderPipe) {
    this.imgUrl = window["orginalImgUrl"];
    this.fileUrl = window["getfile"];
    var str = this.router.url;
    this.route = str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
  }
  ngOnInit() {
    this.spinner.show();
    this.paginationPageNumber = 1;
    this.itemsPerPage = 5;
    this.getMenuName();
    this.getNecGuidelines();


  }

  search() {
    this.paginationPageNumber = 1;
  }

  getMenuName() {
    this.http.get(this.appComponent.APIUrl + 'MenuMaster/', {
    }).subscribe((data: any) => {
      this.MenuList = data.menuMasterDTO.filter(x => x.link == this.route);
      this.title = this.MenuList[0].title;
      this.multipleEntry = this.MenuList[0].multipleEntry;
    });
  }
  getNecGuidelines() {
    this.necSpinner = true;
    this.http.get(this.appComponent.APIUrl + 'Post/GetPostByRoute/' + this.route, {
    }).subscribe((data: any) => {
      this.necGuidlines = data.postDTO.filter(x => x.status == 'Active' && x.displayonhome == 1);
      this.necGuidlinesCount = this.necGuidlines.length;
      this.currentDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd' + 'T00:00:00');
      this.necSpinner = false;
    });
  }
  itemPerPagePagination(event: any) {
    this.itemsPerPage = event.target.value;
  }
}
